import {
    clearStyle,
    requestFailed,
    requestStarted,
    didReceiveStyles,
    didReceiveStyle,
    requestSucceeded,
    clearStyles,
    saveScrollpos
} from "./actions";
import {
    requestComments,
    receiveComments,
    clearComments,
} from "../comment/actions";
import {Map, OrderedMap} from "immutable";
import {addDataAction, updateDataAction} from "../_data/actions";
import StyleRepository from "../_repositories/styleRepository";
import CommentRepository from "../_repositories/commentRepository";
import Style from "../_data/models/Style";
import Comment from "../_data/models/Comment";
import {plainToClass} from "class-transformer";
import {getCurrentUser} from "../_helpers/utils";
import Meta from "../_data/models/Meta";
import * as _ from "lodash";
import {ResourceType} from "../_helpers/data";
import {styleByIdSelector, stylesSelector} from "../_data/selectors";
import {createOrderedMapfromIDs} from "../_helpers/utils";
import {myStylesSelector} from "./selectors";

export function saveScrollPosition(scrollPosition) {
    return (dispatch, getState) => {                
        dispatch(saveScrollpos(scrollPosition));
    }    
}

export function initializeStyles() {
    return (dispatch, getState) => {
              
        const styles = createOrderedMapfromIDs(myStylesSelector(getState()).ids, stylesSelector(getState()));
        const totalStylesLoaded = styles.toArray().length;
        const stylesMeta = myStylesSelector(getState()).meta;        
        
        if(!totalStylesLoaded || (stylesMeta!=null && stylesMeta.totalCount > totalStylesLoaded)) {            
            if(stylesMeta!=null && stylesMeta.nextPage < stylesMeta.totalPages)
                dispatch(fetchStylesByUser(stylesMeta.cursor, stylesMeta.nextPage));            
            else {
                dispatch(clearStyles());
                dispatch(fetchStylesByUser());            
            }
        }
            
    }
}

export function initializeStyle(style_id) {
    return (dispatch) => {
        dispatch(clearComments());
        dispatch(fetchStyle(style_id));        
    }
}

export function fetchStyle(id) {
    return (dispatch, getState) => {
        // here we check if the style we wanna fetch already exist in our state and return it so 
        // we can avoid server requests everytime we wanna fetch a style.
        const style = styleByIdSelector(getState(), parseInt(id));
        if (!style) {                             
            dispatch(clearStyle());
            dispatch(requestStarted());
            StyleRepository.getById(id).then(data => {
                if (data) {
                    const {style} = data;
                     if (data.error) {
                        return dispatch(requestFailed({requestErrors: ["Failed to retrieve styles."]}));
                    }

                    dispatch(addDataAction({
                        resource: ResourceType.style,
                        data: [style]
                    }));

                    dispatch(didReceiveStyle({
                        id: style.id,                
                    }));
                }
                return dispatch(requestSucceeded());
            });
        }      
    }
}

export function fetchStylesByUser(cursor: number = null, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestStarted());
        StyleRepository.getByUserId(getCurrentUser(), cursor, page, perPage).then(data => {
            const {styles, meta} = data;
            // Todo: handle errors
            if (data.error) {
                return dispatch(requestFailed({requestErrors: ["Failed to retrieve styles."]}));
            }
            
            const styleIds: number[] = styles.map((style) => style.id);

            dispatch(addDataAction({
                resource: ResourceType.style,
                data: styles
            }));

            dispatch(didReceiveStyles({
                ids: styleIds,
                meta: plainToClass(Meta, meta),
            }));

            return dispatch(requestSucceeded());
        });
    }
}


// WEBPACK FOOTER //
// ./app/client/style/middlewares.ts